import { colors } from '@workday/canvas-kit-react'

export type UnitStatus = 'DP' | 'AK' | 'ER' | 'SG' | 'OS' | 'AE' | 'TR' | 'TA' | 'AR'

export const unitStatusDescription = (unitStatus: UnitStatus) => {
  switch (unitStatus) {
    case 'DP':
      return 'Dispatched'
    case 'AK':
      return 'Acknowledged'
    case 'ER':
      return 'Enroute'
    case 'SG':
      return 'Staged'
    case 'OS':
      return 'On Scene'
    case 'AE':
      return 'Available On Scene'
    case 'TR':
      return 'Transport'
    case 'TA':
      return 'Transport Arrived'
    case 'AR':
      return 'Cleared From Incident'
  }
}

export const unitStatusColor = (unitStatus: UnitStatus) => {
  switch (unitStatus) {
    case 'DP':
    case 'AK':
      return 'rgb(245, 124, 0)'
    case 'ER':
      return 'rgb(0, 204, 0)'
    case 'SG':
    case 'OS':
    case 'AE':
      return 'rgb(204, 0, 0)'
    case 'TR':
      return 'rgb(255, 193, 7)'
    case 'TA':
      return 'rgb(25, 118, 210)'
    case 'AR':
      return colors.blackPepper300
  }
}
